import { useAutoAllocateContext } from './AutoAllocateAllContext';

export default function useAutoAllocateButton(args = {}) {
  const { onSuccess } = args;
  const { handleAutoAllocate, isAutoAllocating } = useAutoAllocateContext();

  const handleClickAutoAllocate = async () => {
    await handleAutoAllocate(onSuccess);
  };

  return {
    handleClickAutoAllocate,
    isAutoAllocating,
  };
}
